import React from 'react';
import { styled } from '@ff/ui';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function MediaDownloadLoader() {
  return (
    <Container>
      <Title>
        <SkeletonLoader variant="text" />
        <SkeletonLoader variant="text" />
      </Title>
      <Section>
        <SkeletonLoader variant="rectangular" height="100%" width="100%" />
      </Section>
    </Container>
  );
}

const Container = styled.Box({
  padding: '29px 36px 54px',
  height: '398px'
});

const Title = styled.Box({
  width: '30%',
  margin: '0px 0px 6px'
});

const Section = styled.Box(({ theme }) => ({
  height: '142px',
  [theme.mediaQueries.lg]: {
    height: '284px',
  }
}));
